/** API → űrlap: számmezők stringként a kontrollált inputokhoz */
export function workerFormFromApi(worker) {
  const loc = worker.location === "Budapest" || worker.location === "Debrecen" ? worker.location : "Debrecen";
  const numStr = (v) => {
    if (v === undefined || v === null || v === "") return "";
    const n = Number(v);
    return Number.isFinite(n) ? String(n) : "";
  };
  return {
    name: worker.name ?? "",
    phone: worker.phone ?? "",
    email: worker.email ?? "",
    position: worker.position ?? "",
    location: loc,
    fuel_eligible: !!worker.fuel_eligible,
    travel_allowance_eligible: !!worker.travel_allowance_eligible,
    travel_allowance_amount:
      worker.travel_allowance_amount != null && worker.travel_allowance_amount !== ""
        ? Number(worker.travel_allowance_amount)
        : 0,
    service_commission_huf: numStr(worker.service_commission_huf),
    polish_commission_pct: numStr(worker.polish_commission_pct),
    budapest_commission_pct: numStr(worker.budapest_commission_pct),
  };
}

export function buildWorkerCommissionPayload(form) {
  const o = { ...form };
  ["service_commission_huf", "polish_commission_pct", "budapest_commission_pct"].forEach((k) => {
    if (o[k] === "" || o[k] === undefined || o[k] === null || Number.isNaN(Number(o[k]))) {
      delete o[k];
    } else {
      o[k] = Number(o[k]);
    }
  });
  return o;
}

/** Telephely szerinti kötelező nullázás / kényszerített értékek mentéskor */
export function finalizeWorkerCommissionPayload(form) {
  const o = buildWorkerCommissionPayload({ ...form });
  const loc = form.location;
  if (loc === "Budapest") {
    o.travel_allowance_eligible = false;
    o.travel_allowance_amount = 0;
    delete o.service_commission_huf;
    o.polish_commission_pct = 0;
  }
  if (loc === "Debrecen") {
    o.fuel_eligible = false;
    o.budapest_commission_pct = 0;
  }
  return o;
}

export function defaultNewWorkerState(location = "Debrecen") {
  return {
    name: "",
    phone: "",
    email: "",
    position: "",
    location,
    fuel_eligible: false,
    travel_allowance_eligible: false,
    travel_allowance_amount: 0,
    service_commission_huf: "",
    polish_commission_pct: "",
    budapest_commission_pct: "",
  };
}

/** Telephely váltáskor rejtett mezők törlése a lokális state-ben */
export function patchLocationChange(prev, newLocation) {
  if (newLocation === "Budapest") {
    return {
      ...prev,
      location: newLocation,
      travel_allowance_eligible: false,
      travel_allowance_amount: 0,
      polish_commission_pct: "",
      service_commission_huf: "",
    };
  }
  if (newLocation === "Debrecen") {
    return {
      ...prev,
      location: newLocation,
      fuel_eligible: false,
      budapest_commission_pct: "",
    };
  }
  return { ...prev, location: newLocation };
}
